<button (click)="onButtonClick($event)" class="add-file-button add-file-button--cardLayout">
    <mat-icon svgIcon="icon-lesson-add"></mat-icon>
    <span>{{ 'activities.lesson.dialog_new' | translate }}</span>
</button>
